export const isDev = import.meta.env.MODE === "development";

const makeBankName = (): string => {
  return "Remium";
};

export const bankName = makeBankName();
